<template>
    <div class="wrapper ">
        <Sidebar />
        <div class="main-panel" id="main-panel">
            <Header />
            <div class="panel-header panel-header-sm">
                <canvas id="bigDashboardChart"></canvas>
            </div>
            <div class="content">
                <Loading v-if="loading === true"/>
                <div id="row">
                    <div class="card">
                        <div class="card-header">
                            <h5 class="card-title">Legal</h5>
                        </div>
                        <div class="card-body">
                            <div class="row mb-4">
                                <div class="col-12">
                                    <label>Terms & Conditions:</label>
                                    <quill-editor class="terms-text" v-model="terms.terms"></quill-editor>
                                </div>
                            </div>

                            <div class="row mb-4">
                                <div class="col-12">
                                    <label>Privacy Policy:</label>
                                    <quill-editor class="terms-text" v-model="privacyPolicy.terms"></quill-editor>
                                </div>
                            </div>

                            <Alert v-if="successMessage.length > 0" :message="successMessage" :error="false"/>
                            <Alert v-if="errorMessage.length > 0" :message="errorMessage" :error="true"/>
                            
                            <button class="btn btn-primary mt-2" @click="update()">Update Legal</button>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    </div>
</template>

<script>
import Legal from '../controllers/legal.controller';
import { quillEditor } from 'vue-quill-editor'

export default {
    name: 'Legal',
    components: {
        quillEditor
    },
    data: function() {
        return {
            loading: false,
            terms: {},
            privacyPolicy: {},
            errorMessage: '',
            successMessage: ''
        }
    },
    beforeMount: async function() {
        this.loading = true;
        this.terms = await Legal.getTerms();
        this.privacyPolicy = await Legal.getPrivacyPolicy();
        this.loading = false;
    },
    methods: {
        resetAlerts() {
            this.successMessage = '';
            this.errorMessage = '';
        },

        async update() {
            this.errorMessage = "";
            this.successMessage = "";
            this.loading = true;

            if (!this.terms.terms || !this.privacyPolicy.terms) {
                this.errorMessage = 'A mandatory field is missing';
            }

            let terms = await Legal.updateTerms(this.terms.type, this.terms.terms);

            if (terms.error) {
                this.errorMessage = terms.error;
            } else if (terms === false) {
                this.errorMessage = "Something went wrong while updating your Terms & Conditions";
            } else {
                let privacyPolicy = await Legal.updateTerms(this.privacyPolicy.type, this.privacyPolicy.terms);
                if (privacyPolicy.error) {
                    this.errorMessage = privacyPolicy.error;
                } else if (privacyPolicy === false) {
                    this.errorMessage = "Something went wrong while updating your Terms & Conditions";
                } else {
                    this.legal = await Legal.getTerms();
                    this.privacyPolicy = await Legal.getPrivacyPolicy();
                    this.successMessage = "Updated Legal Successfully";
                }
            }

            this.loading = false;
        }
    }
}
</script>